/* AOBA PDP + AJAX cart drawer. v4: idempotent accordion binding (fixes double-toggle). Idempotent. */
(function () {
  'use strict';
  var money = function (paise) { return '\u20B9' + (paise / 100).toLocaleString('en-IN'); };

  /* ---------- cart drawer (global) ---------- */
  function drawerEls() {
    return { cd: document.querySelector('[data-ao-cd]'), ov: document.querySelector('[data-ao-cd-ov]') };
  }
  function openDrawer() {
    var e = drawerEls(); if (!e.cd) { window.location.href = '/cart'; return; }
    if (e.cd.hasAttribute('hidden')) { e.cd.removeAttribute('hidden'); void e.cd.offsetWidth; }
    requestAnimationFrame(function () {
      e.cd.classList.add('open');
      if (e.ov) { e.ov.classList.add('open'); e.ov.setAttribute('aria-hidden', 'false'); }
      document.body.style.overflow = 'hidden';
    });
    refreshCart();
  }
  function closeDrawer() {
    var e = drawerEls(); if (!e.cd) return;
    e.cd.classList.remove('open');
    if (e.ov) { e.ov.classList.remove('open'); e.ov.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
    setTimeout(function () { if (!e.cd.classList.contains('open')) e.cd.setAttribute('hidden', ''); }, 350);
  }
  window.aobaOpenCart = openDrawer;

  function refreshCart() {
    var e = drawerEls(); if (!e.cd) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var list = e.cd.querySelector('[data-ao-cd-items]');
      var count = cart.item_count;
      e.cd.querySelectorAll('[data-ao-cd-count]').forEach(function (n) { n.textContent = count; });
      document.querySelectorAll('.cart-chip__count').forEach(function (n) { n.textContent = count; });
      var sub = e.cd.querySelector('[data-ao-cd-sub]');
      if (sub) sub.textContent = money(cart.items_subtotal_price);
      var nudge = e.cd.querySelector('[data-ao-cd-nudge]');
      if (nudge) nudge.classList.toggle('show', count === 1);
      if (!list) return;
      if (!cart.items.length) { list.innerHTML = '<div class="ao-cd-empty">Your cart is empty.<br>Your island wardrobe awaits \u2728</div>'; return; }
      list.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : '';
        return '<div class="ao-cd-item">' +
          '<div class="im">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="in"><div class="n">' + it.product_title + '</div>' +
          '<div class="v">' + (it.variant_title && it.variant_title !== 'Default Title' ? 'Size: ' + it.variant_title : '') + '</div>' +
          '<div class="r"><div class="ao-qty"><button data-ao-cd-q="' + (i + 1) + ':' + (it.quantity - 1) + '">\u2212</button><span>' + it.quantity + '</span><button data-ao-cd-q="' + (i + 1) + ':' + (it.quantity + 1) + '">+</button></div>' +
          '<span class="pr">' + money(it.final_line_price) + '</span></div>' +
          '<button class="rm" data-ao-cd-q="' + (i + 1) + ':0">Remove</button></div></div>';
      }).join('');
      list.querySelectorAll('[data-ao-cd-q]').forEach(function (b) {
        b.addEventListener('click', function () {
          var p = this.dataset.aoCdQ.split(':');
          fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +p[0], quantity: +p[1] }) })
            .then(function () { refreshCart(); });
        });
      });
    });
  }

  function initDrawer(root) {
    var cd = (root || document).querySelector('[data-ao-cd]');
    if (!cd || cd.dataset.aoInit) return;
    cd.dataset.aoInit = '1';
    var ov = document.querySelector('[data-ao-cd-ov]');
    cd.querySelectorAll('[data-ao-cd-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (ov) ov.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeDrawer(); });
    document.querySelectorAll('a[href$="/cart"]').forEach(function (a) {
      a.addEventListener('click', function (ev) { ev.preventDefault(); openDrawer(); });
    });
    refreshCart();
  }

  /* ---------- description splitter ---------- */
  function splitDescription(pdp) {
    var desc = pdp.querySelector('[data-ao-desc]');
    var fab = pdp.querySelector('[data-ao-fabric]');
    if (!desc) return;
    var clean = function (t) { return (t || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
    var kids = Array.prototype.slice.call(desc.children);
    var target = null, fabNodes = [], dropNodes = [];
    kids.forEach(function (el) {
      var t = clean(el.textContent);
      var isHead = /^H[1-6]$/.test(el.tagName) || (el.tagName === 'P' && el.querySelector('strong') && t.length > 0 && t.length < 40);
      if (isHead) {
        if (/^(care|wash|composition|fabric|material)/.test(t)) target = 'fab';
        else if (/^(exchange|return|shipping|delivery)/.test(t)) target = 'drop';
        else if (t.length < 40) target = null;
      }
      if (target === 'fab') fabNodes.push(el);
      else if (target === 'drop') dropNodes.push(el);
    });
    if (fab && fab.hasAttribute('data-ao-default') && fabNodes.length) {
      fab.innerHTML = '';
      fabNodes.forEach(function (n) { fab.appendChild(n); });
    } else if (fabNodes.length) {
      fabNodes.forEach(function (n) { n.remove(); });
    }
    dropNodes.forEach(function (n) { n.remove(); });
    var first = desc.firstElementChild;
    if (first) {
      var st = first.querySelector('strong');
      if (st && clean(st.textContent) === 'description') {
        var nx = st.nextSibling;
        if (nx && nx.nodeName === 'BR') nx.parentNode.removeChild(nx);
        st.parentNode.removeChild(st);
      } else if (/^H[1-6]$/.test(first.tagName) && clean(first.textContent) === 'description') {
        first.remove();
      }
    }
  }

  /* ---------- PDP ---------- */
  function initPdp(root) {
    var pdp = (root || document).querySelector('[data-ao-pdp]');
    if (!pdp || pdp.dataset.aoInit) return;
    pdp.dataset.aoInit = '1';
    var $ = function (s) { return pdp.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(pdp.querySelectorAll(s)); };
    var variants = JSON.parse($('[data-ao-variants]').textContent);
    var current = variants.find(function (v) { return v.available; }) || variants[0];
    var qty = 1;

    try { splitDescription(pdp); } catch (e) { /* never block the page */ }

    $$('[data-ao-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-ao-thumb]').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var main = $('[data-ao-main-img]');
        main.src = t.dataset.aoThumb; main.srcset = '';
      });
    });

    function selectVariant(v) {
      current = v;
      $$('[data-ao-size]').forEach(function (b) { b.classList.toggle('on', +b.dataset.aoSize === v.id); });
      var lbl = $('[data-ao-selsize]'); if (lbl) lbl.textContent = v.title;
      var sel = $('[data-ao-satc-sel]'); if (sel) sel.value = v.id;
      var low = $('[data-ao-lowstock]');
      if (low) {
        if (v.available && v.qty > 0 && v.qty <= 5) { low.textContent = '\u26A1 Only ' + v.qty + ' left in size ' + v.title; low.classList.add('show'); }
        else low.classList.remove('show');
      }
      $$('[data-ao-atc]').forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? 'Add to Cart' : 'Sold Out'; });
    }
    $$('[data-ao-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = variants.find(function (x) { return x.id === +b.dataset.aoSize; });
        if (v) selectVariant(v);
      });
    });
    var satcSel = $('[data-ao-satc-sel]');
    if (satcSel) satcSel.addEventListener('change', function () {
      var val = +this.value;
      var v = variants.find(function (x) { return x.id === val; });
      if (v) selectVariant(v);
    });

    $$('[data-ao-qminus]').forEach(function (b) { b.addEventListener('click', function () { qty = Math.max(1, qty - 1); $('[data-ao-qval]').textContent = qty; }); });
    $$('[data-ao-qplus]').forEach(function (b) { b.addEventListener('click', function () { qty += 1; $('[data-ao-qval]').textContent = qty; }); });

    $$('[data-ao-atc]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: current.id, quantity: qty }) })
          .then(function (r) { return r.json(); })
          .then(function () { b.disabled = false; openDrawer(); })
          .catch(function () { b.disabled = false; });
      });
    });
    var buy = $('[data-ao-buynow]');
    if (buy) buy.addEventListener('click', function () { window.location.href = '/cart/' + current.id + ':' + qty; });

    $$('[data-ao-acc]').forEach(function (b) {
      if (b.dataset.aoAccInit) return;
      b.dataset.aoAccInit = '1';
      b.addEventListener('click', function () { b.parentElement.classList.toggle('open'); });
    });

    var pinBtn = $('[data-ao-pin-btn]');
    if (pinBtn) pinBtn.addEventListener('click', function () {
      var pin = $('[data-ao-pin]').value.replace(/\D/g, '');
      var est = $('[data-ao-pin-est]');
      if (pin.length !== 6) { est.textContent = 'Please enter a valid 6-digit pincode.'; est.classList.add('show'); return; }
      var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var a = new Date(); a.setDate(a.getDate() + 3);
      var z = new Date(); z.setDate(z.getDate() + 7);
      est.innerHTML = '\u2713 Delivering to <b>' + pin + '</b> \u2014 order today, get it by <b>' + fmt(a) + ' \u2013 ' + fmt(z) + '</b>. COD available (+\u20B9150).';
      est.classList.add('show');
    });

    var anchor = $('[data-ao-buynow]') || $('[data-ao-atc]');
    var satc = $('[data-ao-satc]');
    if (anchor && satc) window.addEventListener('scroll', function () {
      satc.classList.toggle('show', anchor.getBoundingClientRect().bottom < 0);
    }, { passive: true });

    var mov = $('[data-ao-mov]');
    if (mov) {
      var chart = JSON.parse($('[data-ao-mchart-data]').textContent);
      var unit = 'in', lastRec = null;
      $$('[data-ao-mopen]').forEach(function (b) { b.addEventListener('click', function (ev) { ev.preventDefault(); mov.classList.add('open'); }); });
      $$('[data-ao-mclose]').forEach(function (b) { b.addEventListener('click', function () { mov.classList.remove('open'); }); });
      mov.addEventListener('click', function (ev) { if (ev.target === mov) mov.classList.remove('open'); });
      var ph = { in: { b: '36', w: '30', h: '38' }, cm: { b: '91', w: '76', h: '96' } };
      $$('[data-ao-munit]').forEach(function (b) {
        b.addEventListener('click', function () {
          unit = b.dataset.aoMunit;
          $$('[data-ao-munit]').forEach(function (x) { x.classList.toggle('on', x === b); });
          $$('[data-ao-mcell]').forEach(function (td) { var vIn = parseFloat(td.dataset.aoMcell); td.textContent = unit === 'cm' ? Math.round(vIn * 2.54) : vIn; });
          $$('[data-ao-mth]').forEach(function (s) { s.textContent = unit; });
          $('[data-ao-mb]').placeholder = ph[unit].b; $('[data-ao-mw]').placeholder = ph[unit].w; $('[data-ao-mh]').placeholder = ph[unit].h;
        });
      });
      var mcalc = $('[data-ao-mcalc]');
      if (mcalc) mcalc.addEventListener('click', function () {
        var f = unit === 'cm' ? 1 / 2.54 : 1;
        var b = parseFloat($('[data-ao-mb]').value) * f, w = parseFloat($('[data-ao-mw]').value) * f, h = parseFloat($('[data-ao-mh]').value) * f;
        var z = $('[data-ao-mz]'), n = $('[data-ao-mn]'), r = $('[data-ao-mres]');
        if (!b || !w || !h || b < 24 || b > 60 || w < 18 || w > 55 || h < 26 || h > 62) { z.textContent = '?'; n.textContent = 'Please enter valid measurements for all three fields.'; r.classList.add('show'); return; }
        var rec = null;
        for (var i = 0; i < chart.length; i++) { if (b <= chart[i].bust + 1 && w <= chart[i].waist + 1 && h <= chart[i].hips + 1) { rec = chart[i]; break; } }
        var beyond = !rec; if (beyond) rec = chart[chart.length - 1];
        lastRec = rec.size; z.textContent = rec.size;
        n.textContent = beyond ? 'Size ' + rec.size + ' is our closest fit. WhatsApp us for personalised fit help.' : 'This size fits your bust, waist & hips. Happy shopping!';
        r.classList.add('show');
        $$('[data-ao-mrow]').forEach(function (tr) { tr.classList.toggle('hl', tr.dataset.aoMrow === rec.size); });
      });
      var mpick = $('[data-ao-mpick]');
      if (mpick) mpick.addEventListener('click', function () {
        mov.classList.remove('open');
        if (!lastRec) return;
        var v = variants.find(function (x) { return x.title === lastRec; });
        if (v && v.available) selectVariant(v);
      });
    }

    selectVariant(current);
  }

  function initAll(root) { initDrawer(root || document); initPdp(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(document); });
})();
